import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'components/PageLayout';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { useRefreshAuthUserOnMount } from './useRefreshAuthUserOnMount';
import { MembershipIAPCheckoutContent } from './MembershipIAPCheckoutContent';

const Content = (): JSX.Element => {
  const { t } = useTranslation();

  useRefreshAuthUserOnMount();

  return (
    <>
      <Helmet>
        <title>{t('membershipCheckout.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <MembershipIAPCheckoutContent />
      </SimplePageLayout>
    </>
  );
};

export const MembershipIAPCheckout = (): JSX.Element => {
  return (
    <PageLayout
      data-cname="MembershipCheckoutPage"
      allowAppBanner={false}
      headerBarProps={{ action: 'back' }}
    >
      <Content />
    </PageLayout>
  );
};
